import { Check } from 'lucide-react';
import { CANCELLATION_OPTIONS } from 'modules/arena/onboarding/content';
import { cn } from 'shared/utils/cn';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepCancellation(state: ArenaOnboardingState) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-ink-secondary">
        Defina até quando o jogador pode cancelar uma reserva com reembolso.
      </p>

      {CANCELLATION_OPTIONS.map((option) => {
        const isSelected = option.value === state.cancellationWindow;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => state.setCancellationWindow(option.value)}
            className={cn(
              'flex items-start justify-between gap-4 rounded-xl border p-4 text-left transition-colors',
              isSelected ? 'border-primary bg-accent-soft/40' : 'border-border/70 hover:border-primary'
            )}
          >
            <div>
              <p className="font-medium text-ink">{option.label}</p>
              <p className="text-sm text-ink-secondary">{option.description}</p>
            </div>
            {isSelected && (
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary text-surface">
                <Check className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" />
              </span>
            )}
          </button>
        );
      })}

      {state.cancellationWindow !== 'sem-reembolso' && (
        <label className="mt-2 flex flex-col gap-1 text-sm text-ink">
          Percentual reembolsável
          <input
            type="range"
            min={0}
            max={100}
            step={10}
            value={state.refundPercentage}
            onChange={(event) => state.setRefundPercentage(Number(event.target.value))}
          />
          <span className="text-ink-secondary">{state.refundPercentage}% do valor pago</span>
        </label>
      )}
    </div>
  );
}
